const translations = {
  title: "CRM — Customer Relations",
  subtitle: "Leads, follow-ups, tasks, and customer interaction history.",
  // Tabs
  tab_opportunities: "Leads & Opportunities",
  tab_tasks: "Tasks & Meetings",
  tab_interactions: "Interaction Log",
  // Opportunities
  opportunities: "Leads",
  newOpportunity: "New Lead",
  leadName: "Lead Name",
  stage: "Stage",
  stage_lead: "Lead",
  stage_contacted: "Contacted",
  stage_qualified: "Qualified",
  stage_proposal: "Proposal Sent",
  stage_negotiation: "Negotiation",
  stage_won: "Won",
  stage_lost: "Lost",
  estimatedValue: "Estimated Value (₹)",
  targetGold: "Target Gold (g)",
  assignedTo: "Assigned To",
  followUpDate: "Follow-Up Date",
  lastContacted: "Last Contacted",
  remarks: "Remarks",
  priority: "Priority",
  priority_low: "Low",
  priority_medium: "Medium",
  priority_high: "High",
  // Tasks
  tasks: "Tasks & Meetings",
  newTask: "New Task",
  taskTitle: "Title",
  taskType: "Type",
  type_task: "Task",
  type_meeting: "Meeting",
  type_follow_up: "Follow-Up Call",
  dueDate: "Due Date",
  status: "Status",
  status_pending: "Pending",
  status_completed: "Completed",
  status_overdue: "Overdue",
  status_cancelled: "Cancelled",
  description: "Description",
  markComplete: "Mark Complete",
  // Interactions
  interactions: "Interaction Log",
  addInteraction: "Add Interaction",
  interactionType: "Type",
  type_note: "Note",
  type_call: "Phone Call",
  type_whatsapp: "WhatsApp",
  type_email: "Email",
  type_sms: "SMS",
  interactionTitle: "Title",
  interactionBody: "Body / Notes",
  staffEmail: "Staff Member",
  interactionDate: "Date",
  // Empty states
  noLeads: "No leads yet.",
  noTasks: "No tasks yet.",
  noInteractions: "No interactions logged.",
  createFirstLead: "Add the first lead to begin tracking.",
  // Columns
  col_lead: "Lead / Customer",
  col_stage: "Stage",
  col_value: "Value",
  col_followUp: "Follow-Up",
  col_assignedTo: "Assigned",
  col_action: "Action",
};

export default translations;
